//MUI
import { styled } from '@mui/material';

//Icons
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

export const ArrowIcon = styled(ArrowForwardIosIcon)({
  width: 50,
  height: 50,
});
